<!-- EditItemModal.vue -->
<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>Edit Item</v-card-title>
      <v-card-text>
        <!-- Edit form goes here -->
        <v-text-field v-model="editedItem.amount" label="Amount"></v-text-field>
        <!-- Add other fields you want to edit -->
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="saveEditedItem">Save</v-btn>
        <v-btn color="error" @click="closeModal">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogValue: Boolean, // Pass in the dialog value from parent component
    editedItem: Object, // Pass in the edited item from parent component
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialogValue(value) {
      this.dialog = value; // Watch for changes in the dialog value
    },
  },
  methods: {
    saveEditedItem() {
      // Save the edited item and emit an event to notify the parent component
      this.$emit('save-edited-item', this.editedItem);

      // Close the modal
      this.closeModal();
    },
    closeModal() {
      // Close the modal and emit an event to notify the parent component
      this.dialog = false;
      this.$emit('close-modal');
    },
  },
};
</script>
